import FooterAlpha from "./FooterAlpha";

export default FooterAlpha;
